import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPartnersSuppliers } from 'modules/_common/api';

export interface IPaging {
  pageNo?: number;
  pageSize?: number;
  params?: any;
}

export const usePartnersQuery = (
  { pageNo, pageSize, params }: IPaging,
  enabled?: boolean | undefined,
) => {
  const {
    data: partnersSuppliers,
    isError: errPartnersSuppliers,
    isLoading: isLoadingPartnersSuppliers,
    isFetching,
  } = useQuery(
    [QUERY_KEYS.RENTALS_PARTNERS_SUPPLIER, pageNo, params],
    () => getPartnersSuppliers({ pageNo, pageSize, params }),
    {
      //   ...getCacheSettings(), // uncomment for loading icon
      enabled: enabled ?? false,
    },
  );

  return {
    partnersSuppliers: partnersSuppliers,
    errPartnersSuppliers,
    isLoadingPartnersSuppliers,
    isFetching,
  };
};
